import { GoDash } from 'react-icons/go'
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md'

export default function HeaderFutureMineralsPriceChange({ change }) {
  if (change > 0) {
    return (
      <div className="border-success text-success flex items-center gap-2 rtl:flex-row-reverse">
        <div className="">{change} %</div>
        <div className="bg-success-600 p-1 text-white">
          <MdArrowUpward />
        </div>
      </div>
    )
  } else if (change < 0) {
    return (
      <div className="flex items-center gap-2 border-danger-600 text-danger-600 rtl:flex-row-reverse">
        <div className="">{change} %</div>
        <div className="bg-danger-600 p-1 text-white">
          <MdArrowDownward />
        </div>
      </div>
    )
  } else {
    return (
      <div className="flex items-center gap-2 border-primary-600 text-primary-600 rtl:flex-row-reverse">
        <div className="">{change} %</div>
        <div className="bg-primary-600 p-1 text-white">
          <GoDash />
        </div>
      </div>
    )
  }
}
